import { message } from 'ui';
import { CreateReminderModal } from 'features/events';
import type { CreateReminderParams } from '../../types';

type P = CreateReminderParams;

const CreateReminder = ({ action, onClose, slotStart }: P) => (
  <CreateReminderModal
    isOpened={Boolean(action)}
    onCancel={() => {
      onClose?.();
    }}
    onSuccess={() => {
      message.success('Reminder created successfully.');
      onClose?.();
    }}
    slotStart={slotStart}
  />
);

export default CreateReminder;
